import React, { useMemo } from "react";
import { Link, useOutletContext } from "react-router-dom";
import "./Roadmap.css";

export default function RoadmapPage() {
  const outlet = useOutletContext();
  const progress = outlet?.progress ?? {};

  const steps = useMemo(() => ([
    { id: "fundamentos", title: "Fundamentos QA", desc: "Bases, mentalidad QA y tipos de testing." },
    { id: "manual", title: "Testing manual", desc: "Diseño de pruebas, exploratorio y reporte." },
    { id: "automation", title: "Automatización de software", desc: "E2E, selectores y buenas prácticas." },
    { id: "api", title: "API Testing", desc: "Postman, contratos, validaciones y flujos." },
    { id: "cicd", title: "CI/CD para QA", desc: "Pipelines, gates, calidad continua." },
    { id: "buenas", title: "Buenas prácticas", desc: "Arquitectura de tests y escalabilidad." },
  ]), []);

  const completedCount = steps.filter(s => progress?.[s.id]?.completed).length;
  const next = steps.find(s => !progress?.[s.id]?.completed)?.title || "Ruta completada ✅";

  return (
    <div>
      <div className="roadmap-head">
        <div className="muted">Progreso: {completedCount}/6</div>
      </div>

      <div className="roadmap-grid">
        {steps.map((s, idx) => {
          const done = !!progress?.[s.id]?.completed;

          return (
            <div key={s.id} className={`rm-card ${done ? "done" : ""}`}>
              {idx !== 0 && <div className="rm-arrow">➜</div>}

              <Link to={`/roadmap/${s.id}`} className="rm-card-inner">
                <div>
                  <div className="rm-card-top">
                    <div className="rm-check">{done ? "✓" : ""}</div>
                    <div className="rm-title">{s.title}</div>
                  </div>
                  <div className="rm-desc muted">{s.desc}</div>
                </div>

                <div className="rm-card-bottom">
                  <button className={`rm-status ${done ? "done" : ""}`}>
                    {done ? "Completado" : "Empezar →"}
                  </button>
                </div>
              </Link>
            </div>
          );
        })}
      </div>

      <div className="roadmap-footer muted">
        Recomendado: <strong>{next}</strong>
      </div>
    </div>
  );
}
